import DashboardOutfitCard from "./DashboardOutfitCard";

export default DashboardOutfitCard;
